// extracted by mini-css-extract-plugin
module.exports = {"image":"styles-module--image--1axRz"};